import { StatusEfacil } from '../../../types/statusEfacilTypes'
import statusEfacilService from './statusEfacilService'

const buscarStatusEfacil = async (): Promise<StatusEfacil[]> => statusEfacilService.buscarStatusEfacil()

export default {
  buscarStatusEfacil
}
